document.getElementById("toggleButton").addEventListener("click", function() {
var content = document.getElementById("hiddenContent");

// 現在の表示状態をチェックして、表示/非表示を切り替える
  if (content.style.display === "none") {
    content.style.display = "block";  // 表示
  } else {
    content.style.display = "none";   // 非表示
  }
});

// すべてのボタンに対してクリックイベントを設定
document.querySelectorAll(".hideButton").forEach(function(button) {
  button.addEventListener("click", function() {
    this.style.display = "none";  // クリックしたボタンを非表示にする
  });
});